import { collection, getDocs, getFirestore } from "firebase/firestore";
import 'firebase/firestore'

const state = {
  groups: [],
};

const mutations = {
  setGroups(state, payload) {
    console.log("payload", payload)
    state.groups = payload;
  }
};

const actions = {
  async loadGroups({ commit }) {
    const groups = [];
    const db = getFirestore();
    const groupSnapshot = await getDocs(collection(db, "groups"));
    groupSnapshot.forEach((doc) => {
      var b = doc.data();
      b.id = doc.id;
      groups.push(b);
    }
    );
    commit("setGroups", groups);
  }
};

const getters = {
  groups(state) {
    return state.groups;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

